import Input, { TextAreaProps } from 'antd/es/input';
import { genTestID } from '../../utils/utils';

const { TextArea } = Input;

type TaggedTextAreaProps = ComponentWithTagProps & TextAreaProps;

const TaggedTextArea = (props: TaggedTextAreaProps) => {
  const { tag } = props;

  return (
    <TextArea {...props} data-testid={genTestID('textArea', tag)} />
  );
};

export default TaggedTextArea;
